import { render, staticRenderFns } from "./PlatformProductTableV2.vue?vue&type=template&id=ce9d16e8&"
import script from "./PlatformProductTableV2.vue?vue&type=script&lang=js&"
export * from "./PlatformProductTableV2.vue?vue&type=script&lang=js&"
import style0 from "./PlatformProductTableV2.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PlatformProductTableV2.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports